import { render, staticRenderFns } from "./RiskAssessment.vue?vue&type=template&id=a5a12d92&scoped=true"
import script from "./RiskAssessment.vue?vue&type=script&lang=js"
export * from "./RiskAssessment.vue?vue&type=script&lang=js"
import style0 from "./RiskAssessment.vue?vue&type=style&index=0&id=a5a12d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a12d92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
